import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { LayoutService } from 'codex-lib';

@Component({
  selector: 'app-envelope',
  templateUrl: './envelope.component.html',
  styleUrls: ['./envelope.component.scss']
})
export class EnvelopeComponent {

  constructor(public layoutService: LayoutService) {
    //  Title Page
    this.layoutService.headerProp.next({ title: 'Codex' });
  }

  // #region TOOLBAR
  @ViewChild('toolbarCodex') toolbar: TemplateRef<any>;
  ngAfterViewInit(): void {
    this.layoutService.toolbarTemplateRef.next(this.toolbar);
  }
}
